module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB4001-32bedf854158a53f2e1306056dbd6573.png";